export default __webpack_public_path__ + "static/media/logo.6102a182.svg";